export function isGroupLifeAvailable() {
  // Once, we start selling again, let's change this to true
  return false
}
